module.exports = "/assets/img/ipallets/i-measure_23045@2x.png";